import { PageTitle } from '../components/layout/PageTitle';

interface PlaceholderPageProps {
  title: string;
  subtitle?: string;
}

const PlaceholderMessage = ({ name }: { name: string }) => (
  <div className="rounded-md border border-border-neutral-soft bg-neutral-soft p-6 text-sm text-neutral-secondary-foreground">
    This screen is not yet implemented. <span className="font-semibold">{name}</span> is a placeholder destination, ready to be replaced with its feature screen.
  </div>
);

/** Reusable, minimal full-page placeholder used for navigation items without a built screen. */
export const PlaceholderPage = ({ title, subtitle }: PlaceholderPageProps) => (
  <>
    <PageTitle title={title} subtitle={subtitle} />
    <PlaceholderMessage name={title} />
  </>
);

/** Compact placeholder used inside a tab panel, where the page heading is already shown. */
export const PlaceholderPanel = ({ name }: { name: string }) => (
  <div className="pt-4">
    <PlaceholderMessage name={name} />
  </div>
);
